import { Box, Center, SegmentedControl, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './logo-type.module.css';

const ACCENT = 'var(--mantine-color-smartico-pink-6)';

const SEGMENTED_BORDER_STYLES = {
    indicator: { backgroundColor: 'var(--mantine-color-body)', border: `2px solid ${ACCENT}`, boxShadow: 'none' },
    label: { padding: '10px 20px' },
};

const FIGMA_TOOLTIP_STYLES = {
    tooltip: { backgroundColor: '#343434', color: '#fff', fontSize: 11, borderRadius: 6 },
    arrow: { backgroundColor: '#343434' },
};

const TabIcon = ({ variant }) => {
    if (variant === 'favicon') {
        return (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="2.25" y="4.25" width="19.5" height="15.5" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
                <rect x="5" y="7" width="4" height="4" rx="1" fill="currentColor" />
                <path d="M11 9h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M5.5 14.5h13M5.5 17h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".38" />
            </svg>
        );
    }
    if (variant === 'none') {
        return (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="2.25" y="4.25" width="19.5" height="15.5" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
                <path d="M5.5 8h13M5.5 11.5h13M5.5 15h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".38" />
            </svg>
        );
    }
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect x="2.25" y="4.25" width="19.5" height="15.5" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
            <rect x="5" y="7" width="14" height="4" rx="1" fill="currentColor" />
            <path d="M5.5 14.5h13M5.5 17h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".38" />
        </svg>
    );
};

const TabLabel = ({ variant, children }) => {
    const { t } = useTranslation();

    return (
    <Tooltip label={t(`logoType.tooltip.${variant}`)} withArrow position="top" multiline w={200} styles={FIGMA_TOOLTIP_STYLES}>
        <Center style={{ gap: 8 }}>
            <TabIcon variant={variant} />
            <span>{children}</span>
        </Center>
    </Tooltip>
    );
};

export const LogoTypeComponent = ({ form, mode, setMode, ...props }) => {

    const { t } = useTranslation();

    const valueMap = {
    '0': 'logo',
    '1': 'favicon',
    '2': 'none'
};

    const onChange = (value) => {
        const prevMode = mode;

        setMode(value);

        if (value === "favicon" && prevMode !== "favicon") {
            if (form.values.logo && form.values.logo !== form.values.favicon) {
                sessionStorage.setItem("studio_full_logo_backup", form.values.logo);
            }

            form.setFieldValue("logo_position", "1");
            form.setFieldValue("linear_gradient_type", "3"); // Bright is the default background per the ticket

            if (!form.values.favicon) {
                form.setFieldValue("is_favicon", "2");
                return;
            }

            form.setFieldValue("logo", form.values.favicon);
            form.setFieldValue("is_favicon", "1");
            return;
    }

        if (value === "logo") {
            const backupLogo = sessionStorage.getItem("studio_full_logo_backup");

            if (prevMode === "favicon" && backupLogo) {
                form.setFieldValue("logo", backupLogo);
                form.setFieldValue("is_favicon", "0");
            } else {
                form.setFieldValue("is_favicon", form.values.logo ? "0" : "2");
            }

            return;
        }

        if (value === "none") {
            form.setFieldValue("logo_position", "1");
            form.setFieldValue("is_favicon", "2");
            return;
        }

            if (value === "favicon") {
             form.setFieldValue("is_favicon", form.values.favicon ? "1" : "2");
    }
    };

    return (
        <Box {...props.wrapperProps} fullWidth>
            <SegmentedControl
                classNames={{ label: classes.label }}
                radius="md"
                value={mode}
                onChange={onChange}
                styles={SEGMENTED_BORDER_STYLES}
                data={[
                    {
                        value: 'logo',
                        label: <TabLabel variant="logo">{t('logo.label')}</TabLabel>,
                    },
                    {
                        value: 'favicon',
                        label: <TabLabel variant="favicon">{t('logoType.profile')}</TabLabel>,
                    },
                    {
                        value: 'none',
                        label: <TabLabel variant="none">{t('logoType.none')}</TabLabel>,
                    },
                ]}
            />
        </Box>
    );
};
